import storageKey from '@sdk/helpers/storage/key';

export const key = storageKey('news');

const storage = window.localStorage;

function list() {
  return JSON.parse(storage.getItem(key)) || {};
}

function update(news) {
  storage.setItem(key, JSON.stringify(news));
}

export function set(id) {
  update({
    ...list(),
    [id]: new Date(),
  });
}

export function get(id) {
  return list()[id];
}
